import { timeline } from "../data/content";
import "./Timeline.css";

export default function Timeline(): JSX.Element {
  return (
    <section className="timeline" id="schedule">
      <div className="container timeline__inner">
        <div className="timeline__intro">
          <p className="timeline__eyebrow">Program</p>
          <h2 className="timeline__title">A nap menetrendje</h2>
        </div>
        <ol className="timeline__list">
          {timeline.map((item, index) => (
            <li className="timeline__item" key={item.title}>
              <div className="timeline__marker">
                <span>{index + 1}</span>
              </div>
              <div className="timeline__details">
                <div className="timeline__meta">
                  <p className="timeline__time">{item.time}</p>
                </div>
                <h3 className="timeline__event">{item.title}</h3>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
